const createGetCadenasReporte =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  () => {
    let request = buildRequestWithAuth("GET", null, {
      "Content-Type": "application/json",
    });

    return fetch(
      `${environment.originacionUrl}/consumo/reportes/cadenas`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => response.json())
      .catch((error) => {
        let resultError = parseError(error, "getCadenasReporte");
        console.error(resultError);
        throw resultError;
      });
  };

const createPostReporteConsumo =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (data) => {
    const requestBody = {
      FechaDesde: data.FechaDesde,
      FechaHasta: data.FechaHasta,
      Estados: data.Estados,
      FechaEstado: data.FechaEstado,
    };

    if (data.CadenaId !== undefined && data.CadenaId !== null) {
      requestBody.CadenaId = data.CadenaId;
    }

    let request = buildRequestWithAuth("POST", requestBody, {
      "Content-Type": "application/json",
    });

    return fetch(`${environment.originacionUrl}/consumo/reportes`, request)
      .then(errorUnlessOk)
      .then((response) => response.json())
      .then((json) => {
        if (!json.url || typeof json.url !== "string") {
          throw new Error("El reporte no fue generado correctamente");
        }
        return json;
      })
      .catch((error) => {
        let resultError = parseError(error, "createReporteConsumo");
        console.error(resultError);
        throw resultError;
      });
  };

export { createPostReporteConsumo, createGetCadenasReporte };
